import AppConstant from '../../../config/app.constants';
import BaseController from '../common/service_ticket_parts.base.controller'

class ServiceTicketPartsAllController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, ServiceTicketPartsService, Modal, $translate, $location, $stateParams) {

        super(Auth, $state, User, ServiceTicketPartsService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.page = 1;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            searchText: '',
            serviceOrderPartsObj: {
                results: [],
                totalRecords: 0,
                loading: false,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            }
        }
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
        this.loadData();
    }

    edit(part) {
        this.$state.go('service-ticket-parts.edit', ({
            id: part.id
        }))
    }

    delete(part) {
        if (this.allowOnlyOnce) return;
        this.allowOnlyOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${part.id}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                $scope.loading = true;
                this.Service.remove(part.id, part.label, part.serialNumber, this.model.currentBranch)
                    .then((data) => {
                        this.allowOnlyOnce = false;
                        modal.close();
                        this.refresh();
                    })
            }),
            negative: (({
                modal,
            }) => {
                this.allowOnlyOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

    refresh() {
        this.loadData();
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    generateSearchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + this.model.searchText + '%'
                },
                {
                    field: 'label',
                    condition: 'like',
                    data: '%' + this.model.searchText + '%'
                }],
                operator: 'OR'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    search() {
        this.page = 1;
        this.model.serviceOrderPartsObj.pagination.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData();
    }

    loadData() {
        const searchObj = this.generateSearchObj();

        this.model.serviceOrderPartsObj.loading = true;
        this.Service.all(searchObj, (this.model.serviceOrderPartsObj.pagination.page - 1) * this.model.serviceOrderPartsObj.pagination.pageLimit, this.model.serviceOrderPartsObj.pagination.pageLimit)
            .then((data) => {
                this.model.serviceOrderPartsObj.totalRecords = data.total;
                this.model.serviceOrderPartsObj.results = data.results;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.serviceOrderPartsObj.loading = false;
            })
    }

}

export default ServiceTicketPartsAllController;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/all/service_ticket_parts.all.controller.js